import { useState } from 'react'

import { BottomSheet } from '@/components/ui/bottom-sheet'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'

import { HIGHLIGHT_COLORS, type HighlightColor } from './highlight-colors'

type HighlightMemoDialogProps = {
  open: boolean
  onClose: () => void
  onSave: (color: HighlightColor, note: string) => void
}

export const HighlightMemoDialog = ({ open, onClose, onSave }: HighlightMemoDialogProps) => {
  const [selectedColor, setSelectedColor] = useState<HighlightColor>('yellow')
  const [note, setNote] = useState('')

  const handleSave = () => {
    onSave(selectedColor, note)
    // リセット
    setNote('')
    setSelectedColor('yellow')
  }

  const handleClose = () => {
    onClose()
    // リセット
    setNote('')
    setSelectedColor('yellow')
  }

  return (
    <BottomSheet open={open} onOpenChange={(open) => !open && handleClose()} title="ハイライトを追加">
      <div className="p-4 space-y-4">
        {/* 色選択 */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">カラー</label>
          <div className="flex gap-3">
            {HIGHLIGHT_COLORS.map((colorOption) => (
              <button
                key={colorOption.value}
                onClick={() => setSelectedColor(colorOption.value)}
                className={`w-10 h-10 rounded-full transition-all ${colorOption.className} ${
                  selectedColor === colorOption.value
                    ? 'ring-2 ring-offset-2 ring-primary scale-110'
                    : 'hover:scale-105'
                }`}
                title={colorOption.label}
              />
            ))}
          </div>
        </div>

        {/* メモ入力 */}
        <div className="space-y-2">
          <label htmlFor="highlight-note" className="text-sm font-medium text-foreground">
            メモ（任意）
          </label>
          <Textarea
            id="highlight-note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="メモを入力..."
            rows={3}
            className="resize-none"
          />
        </div>

        {/* ボタン */}
        <div className="flex gap-3">
          <Button variant="outline" onClick={handleClose} className="flex-1">
            キャンセル
          </Button>
          <Button onClick={handleSave} className="flex-1">
            保存
          </Button>
        </div>
      </div>
    </BottomSheet>
  )
}
